import { Reveal } from "@/components/motion";
import { MapPin, Phone, Clock } from "lucide-react";
import { CLINIC } from "@/lib/api";

export default function Footer() {
  return (
    <footer id="contact" className="bg-[var(--ink)] text-white pt-24 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <img src="/assets/logo.png" alt="Shah Eye Care Centre" className="h-14 w-auto bg-white rounded-xl p-2" />
              <p className="mt-6 font-display text-3xl sm:text-4xl leading-tight text-white/90 max-w-md">
                Where Trust meets Vision.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-8">
            <Reveal delay={0.05}>
              <MapPin className="text-[var(--teal-light)] mb-3" size={22} />
              <h4 className="font-medium mb-2">Visit Us</h4>
              <p className="text-white/60 text-sm leading-relaxed">{CLINIC.address}</p>
              <a
                data-testid="map-link"
                href={`https://www.google.com/maps/search/${encodeURIComponent(CLINIC.address)}`}
                target="_blank"
                rel="noreferrer"
                className="mt-3 inline-block text-sm text-[var(--teal-light)] hover:underline"
              >
                Open in Maps →
              </a>
            </Reveal>
            <Reveal delay={0.1}>
              <Phone className="text-[var(--teal-light)] mb-3" size={22} />
              <h4 className="font-medium mb-2">Call Us</h4>
              <a data-testid="phone-link" href={`tel:${CLINIC.phone}`} className="text-white/60 text-sm hover:text-white">{CLINIC.phone}</a>
            </Reveal>
            <Reveal delay={0.15}>
              <Clock className="text-[var(--teal-light)] mb-3" size={22} />
              <h4 className="font-medium mb-2">Hours</h4>
              <p className="text-white/60 text-sm leading-relaxed">
                Mon–Sat (exc. Fri): 10 AM – 1:30 PM<br />
                Fri & Sun: 10 AM – 12:30 PM
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">© {new Date().getFullYear()} Shah Eye Care Centre, Jammu. All rights reserved.</p>
          <a data-testid="admin-link" href="/admin" className="text-white/40 text-sm hover:text-[var(--teal-light)]">Admin</a>
        </div>
      </div>
    </footer>
  );
}
